import moment from "moment/moment";

export const searchResultMethods = {
    methods: {
        getPenaltyInfo(penalties, isCard = false) {
            let text = "";
            if (!penalties || !penalties.length)
                text = isCard ? this.localizeList.penaltiesUponRequestCard : this.localizeList.penaltiesUponRequestRow;
            else {
                const needHotelName = penalties.length > 1;
                penalties.forEach(h => {
                    if (needHotelName)
                        text += `&#8226; ${h.Key}<br />`;

                    h.Value.forEach(p => {
                        if (p.Amount > 0) {
                            text += (isCard ? this.localizeList.cancellationPolicyInfoCard : this.localizeList.cancellationPolicyInfoRow)
                                .replace("{0}", this.correctPrice(p.TotalAmount))
                                .replace("{1}", p.Currency)
                                .replace("{2}", this.correctDate(p.Date));
                        } else if (p.NmbrOfNights > 0) {
                            text += (isCard ? this.localizeList.cancellationPolicyWithNightsCard : this.localizeList.cancellationPolicyWithNightsRow)
                                .replace("{0}", this.correctPrice(p.NmbrOfNights))
                                .replace("{1}", this.correctDate(p.Date));
                        } else {
                            text += (isCard ? this.localizeList.cancellationPolicyWithoutPenaltyInfoCard : this.localizeList.cancellationPolicyWithoutPenaltyInfoRow)
                                .replace("{0}", this.correctDate(p.Date));
                        }
                    });
                });
            }
            return text
        },
        correctDate(date) {
            if (!date) return '';
            let res = date.split("T")[0].split("-").reverse().join(".");
            res = moment(date).format("DD.MM.YYYY");
            return res
        },
        correctPrice(val) {
            const isFloat = val % 1 !== 0;
            let res = new Intl.NumberFormat().format(val);

            if (res.includes(".") || !isFloat) {
                res = res.replace(/,/g, " ");
            } else {
                res = res.replace(/,/g, ".");
            }
            res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
            return res
        }
    }
};

export const showPenaltyAndTotalPrice = {
    computed: {
        showCancellationPolicy: {
            get() {
                return this.$store.getters['getSettings'].ShowTotalPriceAndPenalty && this.$store.getters['tour/getShowCancellationPolicy']
            },
            set() { }
        },
        showTotalPrice: {
            get() {
                return (this.$store.getters['tour/getIsAuthenticated'] || this.$store.getters['tour/getIsAuthenticatedRecently']) && this.$store.getters['getSettings'].ShowTotalPriceAndPenalty && this.$store.getters['tour/getShowTotalPrice']
            },
            set() { }
        }
    },
};